import { configureStore } from "@reduxjs/toolkit";
import settingSlice from "./slice/settings";
import instrumentSlice from "./slice/instrument";
import realtimeSlice from "./slice/realtime";

export const store = configureStore({
  reducer: { instrument: instrumentSlice.reducer, companySettings: settingSlice.reducer, realtime: realtimeSlice.reducer },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: true,
});
